// extracted by mini-css-extract-plugin
export default {"ddArrow":"yca7doK_ZX1_peLEsqDG","ddMain":"pnTrNyWhhYFkqupo9v8O","ddItem":"hiICUqR7BTRUeLlrBOb7","ddLabel":"FSoGCaJyMo8m7ZCx09gH","placeHolderShimmer":"DHRVrVVhMYD8qkhu4RRC"};